import axios from 'axios';
const axiosInit = axios.create({
    baseURL: "https://485jb78364.zicp.fun/",
    // baseURL: "http://129.211.214.215:7534",
    time: 3000,
})
//请求拦截
axiosInit.interceptors.request.use(
    (config) => {
        if (localStorage.getItem('Authorization')) {
            config.headers['Authorization'] = localStorage.getItem('Authorization');
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    }
)

//响应拦截
axiosInit.interceptors.response.use(
    (response) => {
        if (response.status == 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    (error) => {
        return Promise.reject(error);
    }
)

export default axiosInit;